import { hasClaimDetailValue } from './hasClaimDetailValue';

/** Format claim-detail currency tiles; returns null when empty so the tile can be hidden. */
export function formatClaimDetailCurrency(value) {
  if (!hasClaimDetailValue(value)) return null;
  const numeric = Number(value);
  if (Number.isNaN(numeric)) return String(value);
  return `$${numeric.toLocaleString('en-US')}`;
}
